export default __webpack_public_path__ + "static/media/sandero-medium1.7d53d62c.jpg";